/**
 * TrafficType
 * 
 * @Author: Focci
 * @Date: 2023-07-18 20:51:34
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 20:51:34
 */

// import PropTypes from 'prop-types'
import { ToggleButtonGroup, ToggleButton } from '@comp/material'
import SVGMotor from '@img/motor.svg'
import SVGBus from '@img/bus.svg'
import SVGBicycle from '@img/bicycle.svg'
import SVGWalk from '@img/walk.svg'

export const options = [
  { label: 'Driving', value: 'driving', icon: <SVGMotor /> },
  { label: 'Driving traffic', value: 'driving-traffic', icon: <SVGBus /> },
  { label: 'Cycling', value: 'cycling', icon: <SVGBicycle /> },
  { label: 'Walking', value: 'walking', icon: <SVGWalk /> },
]

export default function TrafficType({
  ...props
}) {
  return (
    <ToggleButtonGroup size="small" color="primary" exclusive {...props}>
      {options.map((item) => (
        <ToggleButton 
          key={item.value} 
          value={item.value}
          disabled={item.value === props.value}
          sx={{
            '&.Mui-selected': (theme) => ({
              backgroundColor: theme.palette.primary.main,
              color: 'white',
              border: 'none'
            })
          }}
        >
          {item.icon}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

// TrafficType.propTypes = {
//   className: PropTypes.string,
// }
